import React, { useEffect, useState } from 'react'
import '../../styles/dashboard.css';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { notify } from '../toast';

const AdminEmployee = () => {

    const { id } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();

    const [employee, setEmployee] = useState({
        employeeId: '',
        name: '',
        mobile: '',
        email: '',
        parent: '',
        gender: '',
        address: '',
        educationQualification: '',
        aadhaar: '',
        bank: '',
        ifsc: '',
        pan: '',
        reportsTo: '',
        role: '',
    });
    const [holders, setHolders] = useState([]);
    const [totalHolders, setTotalHolders] = useState(1);

    const [pageLoading, setPageLoading] = useState(false);

    const axiosPrivate = useAxiosPrivate();

    const fetchHoldersByEmployee = async () => {
        try {

            if (totalHolders === holders.length) return notify('info', 'End of list reached')

            setPageLoading(true);

            const response = await axiosPrivate.get(`/admin/getHoldersByEmployees/${id}?page=${Math.ceil(holders.length / 10) + 1}`);

            const data = response?.data
            setHolders(prev => [...prev, ...data?.holdersByEmployees]);
            setTotalHolders(data?.total)

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setPageLoading(false);
        }
    }

    const fetchEmployeeDetails = async () => {
        try {

            const response = await axiosPrivate.get(`/admin/getEmployeeDetails/${id}`);

            const data = response?.data
            setEmployee(data);
        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchHoldersByEmployee();
        fetchEmployeeDetails();

        // eslint-disable-next-line
    }, []);

    return (
        <div className='container'>

            <div className='employeeDetailsCard'>
                <div style={{ textAlign: 'right' }} >
                    <button className='approve-btn' style={{ fontSize: '1rem' }} onClick={() => navigate(`/employeeEdit/${employee._id}`)}>Edit</button>
                </div>
                <div className='formRow'>
                    <div className='formGroup'>
                        <p><strong>ID : </strong>{employee.employeeId}</p>
                        <p><strong>Name : </strong>{employee.name}</p>
                        <p><strong>Mobile : </strong>{employee.mobile}</p>
                        <p><strong>Email : </strong>{employee.email}</p>
                        <p><strong>Parent : </strong>{employee.parent}</p>
                        <p><strong>Gender : </strong>{employee.gender}</p>
                        <p><strong>Reports to : </strong>{employee.reportsTo?.name ?? 'Admin'}</p>
                    </div>
                    <div className='formGroup'>
                        <p><strong>Address : </strong>{employee.address}</p>
                        <p><strong>Education qualification : </strong>{employee.educationQualification}</p>
                        <p><strong>Aadhaar : </strong>{employee.aadhaar}</p>
                        <p><strong>Bank account number : </strong>{employee.bank}</p>
                        <p><strong>IFSC : </strong>{employee.ifsc}</p>
                        <p><strong>pan : </strong>{employee.pan}</p>
                        <p><strong>Hierarchy : </strong>{employee.role?.replace('_', ' ')}</p>
                    </div>
                </div>
            </div>

            {// @ts-ignore
                holders?.length !== 0 &&
                <>
                    <h2 style={{ margin: '20px 0' }}>
                        Holders registered by <i style={{ color: 'var(--primary-text-color)' }}>{state?.name}</i>
                    </h2>

                    <section className="user-list">
                        <div className="list-header">
                            <span>Name</span>
                            <span>Mobile</span>
                            <span>Member count</span>
                        </div>

                        <div className="list-body">
                            {// @ts-ignore
                                holders.map((holder) => (
                                    <div className="list-row" key={holder?._id}>
                                        <span className='truncate' title={holder?.name} data-label="Name">{holder?.name}</span>
                                        <span className='truncate' title={holder?.mobile} data-label="Mobile">{holder?.mobile}</span>
                                        <span className='truncate' title={holder?.members?.length} data-label="Member count">{holder?.members?.length || 0}</span>
                                    </div>
                                ))
                            }
                        </div>

                    </section>
                </>
            }

            {
                totalHolders !== holders.length ?
                    <div>
                        <button className='add-btn' disabled={pageLoading} onClick={fetchHoldersByEmployee}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
                    </div>
                    : <></>
            }
        </div >
    )
}

export default AdminEmployee
